import { render, staticRenderFns } from "./changePwdUser.vue?vue&type=template&id=34d559ba&lang=pug&"
import script from "./changePwdUser.vue?vue&type=script&lang=js&"
export * from "./changePwdUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports